// extracted by mini-css-extract-plugin
export default {"mail":"MailComponent_mail__h7Djv","img":"MailComponent_img__bRnYG"};